import * as Sentry from "@sentry/nextjs";
import { err } from "neverthrow";

import { safeFetchJson } from "@trip/utils";

import { env } from "~/env";

// Version of safeFetch that logs and squashes the fetch related errors
export function safeNextFetch<T = unknown>(
  input: URL | string,
  init?: RequestInit,
) {
  return safeFetchJson<T>(input, init).orElse((error) => {
    if (env.NEXT_PUBLIC_VERCEL_URL === "development") {
      console.error(error);
    }
    const errorInstance =
      "error" in error ? error.error : new Error(error.type);
    Sentry.captureException(errorInstance, {
      contexts: {
        posthog: {
          ...(error.type === "http"
            ? {
                status: error.status,
                headers: Object.fromEntries(error.headers.entries()),
                response: error.json,
                url: error.url,
              }
            : error.type === "json-parse"
              ? {
                  message: error.message,
                }
              : {
                  message: error.error.message,
                  stack: error.error.stack,
                }),
          type: error.type,
        },
      },
    });
    return err({ type: "fetch" as const, error });
  });
}
